import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthModule } from './auth/auth.module';
import { IwComponentsModule } from './components/iw-components.module';
import { ConfigHeadersService } from './services/config-headers.service';
import { RestService } from './services/rest/rest.service';
import { TenantLicenseService } from './services/tenant-license.service';
import { UserLicenceService } from './services/user-licence.service';
import {UuidLicenseService} from "./services/uuid-license.service";

@NgModule({
  imports: [
    CommonModule,
    AuthModule,
    HttpClientModule,
    IwComponentsModule,
  ],
  providers: [
    ConfigHeadersService,
    TenantLicenseService,
    UserLicenceService,
    UuidLicenseService,
    RestService,
  ],
  exports: [IwComponentsModule],
})
export class CoreModule {
}
